export const visit = (vm, at) => {
vm(require("foundations-components/lang/id.lyaml"));
at({ "id": { "placeholder": "placehorder" } });
};